import If from '@/components/util/IF';
import useItemContext from '@/hooks/useItemContext';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import i18next from 'i18next';
import Link from 'next/link';
import React, { useMemo } from 'react';

const ProductEcomItemVariants = () => {
    const { item: product } = useItemContext();
    const currentVariant = useMemo(() => product?.variants?.find((v) => v.slug === product?.slug), [product?.slug, product?.variants]);
    return (
        <If condition={[currentVariant, product?.variants]}>
            <div className="mb-[20px]">
                <Menu as="div" className="relative inline-block text-left">
                    <div>
                        <MenuButton className="group inline-flex justify-center text-sm font-medium text-blue15 hover:text-blue12">
                            {i18next.t('common:item-text.variant')}: <span className="ml-2">{currentVariant?.name}</span>
                            <ChevronDownIcon
                                aria-hidden="true"
                                className="-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-blue15 group-hover:text-blue12"
                            />
                        </MenuButton>
                    </div>
                    <MenuItems
                        transition
                        className="absolute left-0 z-10 mt-2 w-40 origin-top-left rounded-md bg-white shadow-2xl ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                    >
                        <div className="py-1">
                            {product?.variants?.map((option) => (
                                <MenuItem key={option.slug}>
                                    <Link
                                        href={`/item/${option.slug}`}
                                        prefetch
                                        replace
                                        className="block w-full text-left px-4 py-2 text-sm font-medium text-blue15 data-[focus]:bg-[#f2f2f2]"
                                    >
                                        {option.name}
                                    </Link>
                                </MenuItem>
                            ))}
                        </div>
                    </MenuItems>
                </Menu>
            </div>
        </If>
    );
};

export default ProductEcomItemVariants;
